import './css/index.css';
import 'components/breadcrumbs';
import 'components/landing-intro';
import 'components/navigation-sub-section';
import 'components/card-event';
import 'components/card-video';
import 'components/card-article';
import 'components/card-intro';
import 'components/card-intro-imageonly';
import 'components/card-newsroom';
import 'components/card-figure';
import 'components/card-content-image';
import 'components/card-background';
import 'components/card-mini-expert';
import 'components/card-newsroom';
import 'components/card-pull-quote';
import 'components/card-promo-boxes';
import 'components/card-quarter';
import 'components/card-quarter-key-role';
import 'components/card-quarter-research-library';
import 'components/group-experts';
import 'components/group-people';
import 'components/group-cards-mini-expert';
import 'components/card-key-areas';
import 'components/link-listing';
import 'components/strip-callout';
import 'components/footer';
import 'components/notification';
import Mediator from 'js/mediator';
import createTabs from 'js/create-tabs';
import createSubSectionScroll from 'js/sub-section-nav-scroll';
import Navigation from 'components/navigation';

Mediator.create( {

    componentClasses: [
        Navigation,
        {
            name: 'events-results',
            module: () => import(
                /* webpackChunkName: 'events-results' */
                'components/events-results'
            )
        }
    ],

    ready() {

        createTabs( '.navigation-sub-section' );
        createSubSectionScroll( '.navigation-sub-section' );

    }

} );
